import type { MaterialDto } from '@/api/ApiClient';

export type MaterialIdLabel = { id: number; label: string };

/** Map API materials to id/label pairs for autocompletes. */
export function toMaterialIdLabelPairs(materials: MaterialDto[]): MaterialIdLabel[] {
  return materials
    .filter((m) => m.id !== undefined && (m.name !== undefined || m.label !== undefined))
    .map((m) => ({
      id: m.id!,
      label: m.name || m.label || '',
    }));
}

/** Substrate / bulk-precursor catalog materials for wafer and starting-material pickers. */
export function toSubstrateMaterialPicks(materials: MaterialDto[]): MaterialIdLabel[] {
  return materials
    .filter((m) => m.id !== undefined && m.name !== undefined && m.name !== 'None' && m.isSubstrate)
    .sort((a, b) => a.name!.localeCompare(b.name!))
    .map((m) => ({
      id: m.id!,
      label: m.name || m.label || '',
    }));
}

/** Non-substrate materials for synthesis product pickers. */
export function toNonSubstrateMaterialPicks(materials: MaterialDto[]): MaterialIdLabel[] {
  return materials
    .filter((m) => m.id !== undefined && m.name !== undefined && m.name !== 'None' && !m.isSubstrate)
    .sort((a, b) => a.name!.localeCompare(b.name!))
    .map((m) => ({
      id: m.id!,
      label: m.name || m.label || '',
    }));
}

/** Materials for general autocompletes (excludes "None"). */
export function toGeneralMaterialPicks(materials: MaterialDto[]): MaterialIdLabel[] {
  return materials
    .filter((m) => m.id !== undefined && m.name !== undefined && m.name !== 'None')
    .sort((a, b) => a.name!.localeCompare(b.name!))
    .map((m) => ({
      id: m.id!,
      label: m.name!,
    }));
}
